import moment from "moment";
import { CreateUserInfoPageUrlParams } from "./createUserInfoPageUrlParams";

export class CreateUserInfoPageUrlRequest implements CreateUserInfoPageUrlParams {
    public constructor(init?: Partial<CreateUserInfoPageUrlParams>) {
        Object.assign(this, init);
        this.timeStamp = moment().toISOString(false);
    }
    apiKey?: string;
    apiSecret?: string;
    applicationId?: string;
    timeStamp?: string;
    appToken?: string;
    userId?: string;
    r?: number;
    brandSlug?: string;
}
